class Form
    constructor: (el) ->
        @.$el = el

        @.preventSubmit = @.$el.classList.contains 'form--prevent-submit'

        @.InitEvents()
        @.$el.classList.add 'form--bound'
        return
    
    InitEvents: ->
        self = @
        if @.preventSubmit
            @.$el.addEventListener 'submit', (e) ->
                e.preventDefault()
                return
        return

BindForms = ->
    document.querySelectorAll '.form:not(.form--bound)'
        .forEach (el) ->
            new Form el
            return
    return

window.addEventListener 'bind-components', BindForms